export default {
  // Page titles and headers
  pageTitle: 'Wow, so many areas you said you are satisfied with.',
  subtitle: 'Choose the THREE areas you are MOST SATISFIED WITH and take a moment to reflect on what that means for you in your life',
  goalsTitle: 'My Goals',
  goalsSubtitle: 'Set your personal goals',
  improveTitle: 'Areas to improve',
  improveSubtitle: 'Choose areas you want to work on',
  satisfiedWith: 'This I am satisfied with',
  wantToImprove: 'This I want to improve',
  howDoYouFeel: 'How do you feel about this?',
  
  // Button labels
  saveGoals: 'Save Goals',
  continueToPlan: 'Continue to Plan',
  backToGoals: 'Back to Goals',
  selectGoals: 'Select Goals',
  clearSelection: 'Clear Selection',
  
  // Loading states
  loadingValues: 'Loading values...',
  loadingGoals: 'Loading goals...',
  savingChoices: 'Saving your choices...',
  loadingOptions: 'Loading your options...',
  savingGoals: 'Saving goals...',
  
  // Selection messages
  maxSelections: 'Maximum {count} selections',
  selectedCount: '{count} selected',
  selectMore: 'Please select {count} more',
  tooManySelected: 'Too many selected. Please deselect some.',
  selectedAreas: 'Selected areas: {count}/{max}',
  goalsSelected: 'You have selected {count} of {max} possible goals',
  areasSelected: 'You have selected {count} of {max} possible areas',
  
  // Instructions
  instructions: 'Instructions',
  selectInstructions: 'Click on the areas you want to select',
  deselectInstructions: 'Click again to deselect',
  maxSelectionReached: 'Maximum selection reached',
  improveInstructions: 'Here is the list of what you said you want to improve.',
  improveInstructionsDetail: 'Go around the circle and click the area that is MOST important for you to IMPROVE.',
  decideYourGoal: 'Now decide on your GOAL',
  yourGoal: 'Your goal',
  selectedImproveArea: 'You have chosen to improve in the area {area} from value {from} to {to}.',
  categoryValueInstruction: 'Click HOW MUCH you want to improve your value. This is what you should achieve.',
  chooseImproveValueHint: 'Now choose what is MOST IMPORTANT TO IMPROVE so you can reach your GOAL.',
  singleChangeOnlyHint: 'Choose 1-3 things you believe need to change so you can reach your GOAL.',
  chooseImproveAmountHint: 'Click HOW MUCH you want to improve each one.',
  chooseSingleRiskImproveHint: 'Choose only ONE area where you have a risk value (1 or 2) that you believe must improve for you to reach this goal. Click the number you want to achieve.',
  chooseOneImproveArea: 'Choose ONE area below and click the value you want to achieve to be confident that you will reach the goal for {area}.',
  workAreaTitle: 'MY WORK',
  combinedGoalRange: 'Goals 1 - {total}',
  combinedActionIntro: 'You have chosen to increase your values as follows: {goals}',
  
  // Plan page translations
  howToReachGoals: 'HOW will you reach your GOALS?',
  yourImportantGoals: 'Here are your most important GOALS. Click on each one and describe as briefly as you can, WHAT you plan to do to achieve the goal.',
  goToEvaluation: 'Go to evaluation',
  fillAllGoals: 'Fill in all your goals to continue',
  valueIncrease: 'I have chosen to increase my value from {from} to {to}.',
  relatedToGoal: 'The following are related to your GOAL.',
  writeBriefly: 'Write very briefly WHAT you will do to reach your goal.',
  goalAchievedBy: 'I want my GOAL to be achieved by:',
  date: 'Date',
  dateRequired: 'You must fill in a date.',
  save: 'Save',
  
  // Categories
  physical: 'Physical',
  mental: 'Mental',
  social: 'Social',
  work: 'Work',
  lifestyle: 'Lifestyle',
  health: 'Health',
  fitness: 'Fitness',
  nutrition: 'Nutrition',
  sleep: 'Sleep',
  stress: 'Stress',
  relationships: 'Relationships',
  workLifeBalance: 'Work-Life Balance',
  
  // Status messages
  goalsSaved: 'Goals saved successfully',
  goalsUpdated: 'Goals updated successfully',
  noGoalsSelected: 'No goals selected',
  pleaseSelectGoals: 'Please select at least one goal',
  selectAtLeastOne: 'Please select at least one area to improve',
  selectAtLeastOneArea: 'Please select at least one area',
  subtitleRange: 'Select between {min} and {max} areas to improve',
  subtitleRangeAreas: 'Choose the THREE areas you are MOST SATISFIED WITH and take a moment to reflect on what that means for you in your life',
  noImprovementsSelected: 'You have not selected anything to improve.',
  
  // Error messages
  errorLoadingGoals: 'Error loading goals',
  errorSavingGoals: 'Error saving goals',
  tryAgainLater: 'Please try again later',
  
  // Dialog messages
  limitReached: 'Limit',
  limitMessage: 'You can only choose one improvement area at a time. Remove the existing selection to choose another.',
  incompleteSelection: 'Incomplete Selection',
  incompleteMessage: 'You must select at least 1 area to improve to continue.',
  selectedGoals: 'Your Selected Goals',
  selectedGoalsSubheader: 'You have selected 3 areas to improve:',
  change: 'Change',
  continue: 'Continue',
  
  // Help text
  helpText: 'Select the areas that are most important to you',
  tipText: 'You can change your selection at any time',
  moreInfo: 'More information about goals',
  
  // Progress
  step1: 'Step 1: Select satisfied areas',
  step2: 'Step 2: Set improvement goals',
  step3: 'Step 3: Create action plan',
  
  // Confirmation
  confirmSelection: 'Confirm Selection',
  confirmMessage: 'Are you sure you want to save these goals?',
  yes: 'Yes',
  no: 'No',
  // Plan results page translations
  summary: 'Summary',
  planComplete: 'Your lifestyle plan is now complete!',
  yourGoals: 'Your goals',
  goalsSummary: 'Here is a summary of your lifestyle plan, connections, and own description:',
  willImprove: 'I will improve',
  goalAchievedByDate: 'The goal should be achieved by {date}.',
  willDoFollowing: 'My description:',
  finallyComplete: 'Finally complete! The next step is to start the right AI plan for your goals.',
  completeLifestylePlan: 'Complete and continue to the AI coach',
  loadingPlan: 'Loading your plan...',
  
  // Feedback modal translations
  closingQuestions: 'Closing questions',
  just4Questions: 'Just 3 closing questions about what you think of Bwell work.',
  questionsAnswered: '{answered} / {total} questions answered',
  helpUsImprove: 'Help us improve',
  noQuestionsAvailable: 'No questions available right now.',
  answerRegistered: 'Answer registered',
  pleaseAnswerAll: 'Please answer all questions to continue',
  sending: 'Sending...',
  sendAnswers: 'Send answers',
  failedToSend: 'Failed to send answers. Please try again.',
  thankYouForFeedback: 'Thank you for your feedback!',
  feedbackHelpsImprove: 'Your answers help us improve Bwell.',
  failedToLoadQuestions: 'Failed to load feedback questions',

  // Goals page titles and messages
  myGoals: 'My Goals',
  thanksForAnswering: 'Thank you for answering the questions. You can now proceed.',
  myLifestylePlan: 'My Lifestyle Plan',
  loadingLifestylePlan: 'Loading your lifestyle plan...',
  creatingImage: 'Creating image...',
  saveAsImageA4: 'Save as image (A4)',
  sendingEmail: 'Sending...',
  emailPlanResult: 'Send the result to my email',
  startMessage: 'Now you know the starting point. Now you need to set some GOALS ahead. WHAT DO YOU WANT TO ACHIEVE?',
  planPreludeMessage: 'Not far to go now. Now it\'s time to decide WHAT you will do to reach your GOALS.',

  // Goals reflection page
  reflectionMessage: 'Great! Take a moment now and think about how it affects your life.',

  // Plan action page translations
  lifestylePlan: 'Lifestyle Plan',
  goal: 'Goal',
  goalNumber: 'Goal {current} - {total}',
  actionPlanTitle: '{goal}',
  valueIncreaseFull: 'I have chosen to increase my value from {from} to {to}.',
  valueIncreaseFactorFull: 'I have chosen to improve {factor} from value {from} to {to}.',
  selectedFactor: 'Selected improvement',
  actionGoalTitle: 'GOAL: {category}',
  toBeCompletedBy: 'To be completed by',
  riskAreasDescription: 'Here are things that affect your chances of managing this. Select up to 3 things and click HOW MUCH you plan to improve each one.',
  loadingFactors: 'Loading factors...',
  noImprovementAreas: 'This goal has no selected connection factors. You can go directly to describing your situation.',
  selectedAreasForGoal: 'Selected connection factors for: {goal}',
  selectedConnectionsForCombinedGoal: 'You have selected what you believe is needed to reach your GOAL: {goal}. Now decide WHEN you want to have reached the GOAL.',
  myActionPlanFor: 'My situation today as I work toward the GOAL {category}',
  actionPlanInstructions: 'Briefly describe in your own words how you experience the negative effects within {category}. This is important information so your BwellAI Coach can support you.',
  writePlanPlaceholder: 'Example: I often get headaches in the evening when I have slept badly and spent a long time on screens...',
  updateLifestylePlan: 'We\'ll see you again when it\'s time to update your Lifestyle Plan.',
  value: 'Value',
  
  // Plan modal translations
  oldPlanWarning: 'This is an old lifestyle plan! The content below may therefore look a bit strange.',
  myWork: 'My Work',
  myLifestyle: 'My Lifestyle',
}; 
